import { IconCheckCircleFillSmall } from '@amzn/stencil-react-icons';

/**
 * The filled check glyph, in the colour v2 uses for a good outcome.
 *
 * One home for the pairing of glyph and token. Scattering
 * `IconCheckCircleFillSmall color="color.status.success-icon"` across features is how
 * the two drift apart — the older `color.text.status.*` family is deprecated, and a
 * literal repeated per call site is a literal that gets missed when it moves again.
 *
 * Decorative. Stencil's icons set `aria-hidden` themselves and ignore an `aria-label`,
 * so a caller with no adjacent text must supply its own accessible name around the
 * glyph rather than on it.
 */
export function SuccessIcon(): JSX.Element {
  return <IconCheckCircleFillSmall color="color.status.success-icon" />;
}
